<fn-modal-header class="modal-header">
  <h5 class="modal-title" mat-dialog-title>Severity</h5>
  <button
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
    (click)="close()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</fn-modal-header>
<mat-dialog-content class="p-15">
  <div class="row forwardMdl">
    <div class="col-12 mb-10">
      <label for="severity" class="form-label">Severity</label>
      <fn-select
        [labelKey]="'name'"
        [inputKey]="'name'"
        [optionList]="sevArray"
        [placeholder]="'Severity'"
        [(ngModel)]="severity"
        [ngModelOptions]="{ standalone: true }"
      >
      </fn-select>
    </div>
    <div class="col-2">
      <div class="">
        <label>Telegram</label>
        <fn-checkbox
          [(ngModel)]="isSendTelegram"
          (change)="selectionCheck($event)"
          [value]=""
        ></fn-checkbox>
      </div>
    </div>
    <div class="col-10">
      <textarea
        class="form-control commentArea"
        placeholder="Add your comment here..."
        [(ngModel)]="commentObject.textComment"
      ></textarea>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row">
    <div class="col-12 pull-end text-end">
      <button class="btn btn-primary btn-round" (click)="Update()">
        Update
      </button>
    </div>
  </div>
</mat-dialog-actions>
